import {Component, ElementRef, EventEmitter, Output, QueryList, ViewChildren} from '@angular/core';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-codigo-redefinicao',
  standalone: true,
  imports: [
    FormsModule
  ],
  templateUrl: './codigo-redefinicao.component.html',
  styleUrl: './codigo-redefinicao.component.css'
})
export class CodigoRedefinicaoComponent {
  @ViewChildren('inputRef') inputs!: QueryList<ElementRef>;

  codigo: string[] = Array(7).fill('');
  @Output() codigoRetorno = new EventEmitter<string>();


  moverFoco(event: any, index: number) {
    const input = event.target;
    const valor = input.value;

    if (valor && index < this.codigo.length - 1) {
      const nextInput = this.inputs.toArray()[index + 1];
      nextInput.nativeElement.focus();
    }
    if (valor === '' && event.inputType === 'deleteContentBackward' && index > 0) {
      const prevInput = this.inputs.toArray()[index - 1];
      prevInput.nativeElement.focus();
    }

    if(this.codigo.every(char => char !== '')) {
      this.codigoRetorno.emit(this.codigo.join(''));
    }
  }

}
